<template>
    <swipe-menu :list="list" />
</template>
<script>
// import GlobalMixin from '@/app/shared/mixins/global';
import MapModuleMixin from '@/components/maps/mixins/MapModuleMixin'
import MapPermissionsMixin from '@/components/maps/mixins/MapPermissionsMixin';

import SwipeMenu from '@/app/shared/components/menu/SwipeMenu.vue';

export default {
    props: {
        moduleCode: {
            required: true,
            type: String,
        }
    },
    mixins: [
        MapPermissionsMixin,
    //    GlobalMixin,
    //    MapModuleMixin,
    ],
    components: {
        SwipeMenu,
    },
    computed: {
        moduleInternalCode: function() {
            return this.moduleCode;
        },
        stateTools() {
            return this.moduleInternalCode ? this.$store.getters.getStateTools(this.moduleInternalCode) : {};
        },
        mapTools(){
            return this.stateTools;
        },
        list: function() {
            return [
                {
                    name: 'pesquisa avançada - TODO',
                    click: () => { this.$store.dispatch(`${this.moduleCode}/openPanel`, ''); },
                    icon: '/map/filter.svg',
                    showItem: false,
                },
                {
                    name: 'ferramentas - TODO',
                    click: () => { this.$store.dispatch(`${this.moduleCode}/openPanel`, ''); },
                    icon: '/map/layers.svg',
                    subitens: [],
                    showItem: false,
                },
                {
                    name: 'camadas',
                    click: () => { this.$store.dispatch(`${this.moduleCode}/openPanel`, 'layers'); },
                    icon: '/map/layers.svg',
                    showItem: this.checkTool('layers'),
                },
                {
                    name: 'dashboard',
                    click: () => { this.$store.dispatch(`${this.moduleCode}/openPanel`, 'dashboard'); },
                    icon: '/map/layers.svg',
                    showItem: this.checkTool('dashboard'),
                },
                {
                    name: 'filtros',
                    click: () => { this.$store.dispatch(`${this.moduleCode}/openPanel`, 'search'); },
                    icon: '/map/filter.svg',
                    showItem: this.checkTool('search'),
                },
                {
                    name: 'backoffice',
                    click: () => { this.$router.push({ name: this.url.view.replace(':moduleCode', this.moduleCode) }); },
                    icon: '/map/backoffice.svg',
                    showItem: this.checkTool('backoffice'),
                },
            ]
        },
    }
}
</script>
